import { render, staticRenderFns } from "./PublicMarketplaceServiceList.vue?vue&type=template&id=572e7c42&"
import script from "./PublicMarketplaceServiceList.vue?vue&type=script&lang=js&"
export * from "./PublicMarketplaceServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports